import { Component, OnInit, Inject } from '@angular/core';
import { DOCUMENT, Location } from '@angular/common';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  year: number;
  hashLoc: string;
  locCode: string;

  constructor( @Inject(DOCUMENT) private document: Document, public location: Location) { }

  ngOnInit() {
    const today: Date = new Date();
    this.year = today.getFullYear();

    const url = document.location.href;

    if (url.indexOf('pt-br') > -1) {
      this.hashLoc = '/';
      this.locCode = 'EN';
    } else {
      this.hashLoc = '/pt-br';
      this.locCode = 'PT';
    }
  }

}
